import { useEffect, useRef } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PageHeader, Panel, LoadingState } from "@/components/common";
import { Activity } from "lucide-react";
import { AlertsList, FreshnessGrid, CertList, HistoryTable } from "@/components/monitor/MonitorParts";

const get = (p) => async () => (await api.get(p)).data;

export default function SyncMonitor() {
  const qc = useQueryClient();
  const alerts = useQuery({ queryKey: ["mon-alerts"], queryFn: get("/monitor/alerts") });
  const fresh = useQuery({ queryKey: ["mon-fresh"], queryFn: get("/monitor/freshness") });
  const certs = useQuery({ queryKey: ["mon-certs"], queryFn: get("/monitor/certificates") });
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) { return; }
    ran.current = true;
    api.post("/monitor/evaluate").then(() => qc.invalidateQueries({ queryKey: ["mon-alerts"] })).catch(() => {});
  }, [qc]);
  return (
    <div data-testid="sync-monitor-page" className="space-y-4">
      <PageHeader title="Sync Health & Alerts" subtitle="Passive monitoring of stored Sharekhan sync data and gateway certificates — never logs in, syncs or trades" icon={Activity} demo={false} testId="sync-monitor-header" />
      <Panel title={`Action required${alerts.data ? ` (${alerts.data.action_required})` : ""}`} testId="mon-alerts-panel">
        <div className="p-4">{alerts.data ? <AlertsList data={alerts.data} /> : <LoadingState label="Checking…" />}</div>
      </Panel>
      <Panel title="Data freshness" testId="mon-fresh-panel"><div className="p-4">{fresh.data ? <FreshnessGrid f={fresh.data} /> : <LoadingState label="Loading…" />}</div></Panel>
      <Panel title="Certificate expiry" testId="mon-cert-panel"><div className="p-4">{certs.data ? <CertList c={certs.data} /> : <LoadingState label="Loading…" />}</div></Panel>
      <Panel title="Synchronization history" testId="mon-history-panel"><div className="p-4"><HistoryTable /></div></Panel>
    </div>
  );
}
